import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/utils/services/api.service';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { LoaderService } from 'src/app/utils/services/loader.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-list',
  templateUrl: './admin-list.component.html',
  styleUrls: ['./admin-list.component.scss']
})
export class AdminListComponent implements OnInit, OnDestroy {
  dtOptions: DataTables.Settings = {};
  allAdmin: any;
  render: number;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  constructor(
    private apiService: ApiService, 
    private toastr: ToastrService,
    private LoaderService:LoaderService
  ) { }

  ngOnInit(): void {
    this.LoaderService.showLoader()
    const that = this;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.render = 1;
    this.showItem();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  async showItem() {
    this.LoaderService.showLoader()
    const that = this;
    await this.apiService.getAllAdmin().subscribe((resp: any) => {
        that.allAdmin = resp.data;
      if(this.render === 1) {
        this.LoaderService.hideLoader()

        this.dtTrigger.next();
      }this.LoaderService.hideLoader()

      this.render = 0;
    });
    // this.LoaderService.hideLoader()

  }

  async changeStatus(id, status) {
  
    if (id == undefined || id == '') {
      this.toastr.error('Admin Id is Invalid');
      return false;
    }
  
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to change the status?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, change it!',
      cancelButtonText: 'Cancel',
    });
  
    if (result.isConfirmed) {
      // this.LoaderService.showLoader();

      let getStatus = status === 'active' ? { "status": "inactive" } : { "status": "active" };
      await this.apiService.changeStausById(id, JSON.stringify(getStatus)).subscribe((response: any) => {
        this.LoaderService.hideLoader();
  
        if (response.success) {
          this.toastr.success(response.message);
          location.reload(); // Reload the page after successful status change
        } else {
          this.toastr.error(response.message);
        }
      }, (error) => {
        this.LoaderService.hideLoader();
        this.toastr.error('Error occurred while changing the status.');
        console.error('Error details:', error); // Log the full error
      });
    } else {
      // this.LoaderService.hideLoader(); // Hide loader if the action is canceled
    }
  }
  

   async deleteUser(id) {
      this.LoaderService.showLoader();
    
      if (id == undefined || id == '') {
        this.toastr.error('admin Id is Invalid');
        return false;
      }
    
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to restore this admin!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      });
    
      if (result.isConfirmed) {
        await this.apiService.deleteAdmin(id).subscribe((response: any) => {
          this.LoaderService.hideLoader();
    
          if (response.success) {
            this.showItem();
            location.reload()
            this.toastr.success("admin deleted successfully");
          } else {
            this.toastr.error('Failed to delete admin.');
          }
        }, (error) => {
          this.LoaderService.hideLoader();
          this.toastr.error('Error deleting admin.');
          console.error('Error details:', error);
        });
      } else {
        this.LoaderService.hideLoader(); // Hide loader if canceled
      }
    }
}
